import { Button } from '@mui/material';
import { IconTrash } from '@tabler/icons-react';
import React from 'react';

export default function BtnTrash({ onDelete, width, fullWidth, style, iconSize = 20, ...props }) {
  return (
    <Button
      variant="outlined"
      width={width}
      fullWidth={fullWidth}
      onClick={onDelete}
      style={style}
      {...props}>
      <IconTrash size={iconSize} />
    </Button>
  );
}
